import { h } from 'preact';
import { TypingIndicator } from '../TypingIndicator';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'TypingIndicator',
  category: '💬 Chat',
  description: '3 dots pulsantes indicando que alguém está digitando',
  usedIn: ['Chat', 'ChatHubPage'],
  example: () => <TypingIndicator />,
};
